import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// @ts-ignore
import Swedish from '@shared/core/data/translations/sv-SE.json';

i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: 'sv',
        fallbackLng: 'sv',
        debug: false,
        resources: {
            sv: { translation: Swedish },
        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
